import React from "react";
import FontAwesome from "react-fontawesome";
function Icons({ name, ...rest }) {
  return (
    <FontAwesome
      name={name}
      style={{
        cursor: "pointer",
        fontSize: "16px",
      }}
      className="text-center"
      {...rest}
    />
  );
}

export default Icons;
